// extracted by mini-css-extract-plugin
export default {"searchBox":"br_lf","resultsOpen":"br_lg"};